module.exports = __webpack_public_path__ + "img/site_type_img_04.708b0d48.png";